export default function withBaseFormsy(superclass) {
  return class extends superclass {
    constructor(props) {
      super(props)
      this.state = { ...(this.state || {}), _userTouched: false }
    }

    updateValidates(exceptName=null) {
      if (this.props.form) {
        setTimeout(() =>
          this.props.form.prevInputNames.map(inputName => {
            if (exceptName === null || exceptName !== inputName) {
              let component = this.props.form.inputs.find(item => item.props.name === inputName)

              var args = [{
                isValid: true,
                externalError: {}
              }];
              component.setState.apply(component, args);
              this.props.form.runValidation(component)
            }
            return true
        }), 10)
      }
    }

    componentWillMount() {
      this.defaultValue()
    }

    defaultValue() {
      const {item, defaultValue} = this.props

      if (!item)
        return

      let value = {service_form_type: item.type}

      switch (item.input_type) {
        case "checkbox":
          value[item.input_type] = defaultValue ? defaultValue.checkbox : item.format.checkbox
          break;
        case "radio":
          value[item.input_type] = defaultValue ? defaultValue.radio : ""
          break;
        case "password":
        case "text":
        case "alphameric":
          value[item.input_type] = defaultValue ? defaultValue : ""
          break;
        case "table":
          const rows = item.format.table.rows
          const cols = item.format.table.columns

          value[item.input_type] = rows.map(row => {
            return cols.map(col => "")
          })
          break
        default:
          break;
      }

      this.props.setValue(value)
    }

    setValue(e) {
      if (!this.state._userTouched) this.setState({ _userTouched: true })
      let value = this.props.getValue()
      const item = this.props.item

      switch (item.input_type) {
        case "checkbox":
          value[item.input_type][e.currentTarget.value] = e.currentTarget.checked
          break;
        case "radio":
        case "password":
        case "text":
        case "alphameric":
          value[item.input_type] = e.currentTarget.value
          break;
        case "table":
          value[item.input_type][e.target.getAttribute("data-row")][e.target.getAttribute("data-col")] = e.currentTarget.value
          break
        default:
          break;
      }

      this.props.setValue(value)
    }
  }
}
